<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <div>
            <!--<p :class="$style.tip">合计&nbsp;&nbsp;&nbsp;&nbsp;经销商: {{dealers}}家 &nbsp;&nbsp;&nbsp;&nbsp;门店: {{stores}}家-->
                <!--&nbsp;&nbsp;&nbsp;&nbsp;人员: {{personnel}}人</p>-->

            <el-table
                    :data="tableData" border
                    tooltip-effect="dark"
                    style="width: 100%">

                <el-table-column
                        prop="store_name"
                        min-width="200"
                        label="门店名称"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="city_name"
                        min-width="120"
                        label="城市"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="clerk_num"
                        label="在职人员"
                        min-width="120"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态"
                        min-width="120"
                        sortable
                >
                    <template slot-scope="scope">
                        <span>{{getStatus(scope.row.status)}}</span>
                    </template>
                </el-table-column>

            </el-table>
        </div>

    </div>
</template>
<script>

    import http from '../../APIService/http'

    export default {
        data () {
            return {

                tableData: [],
            }
        },
        created () {
            let obj = this.$store.getters.getStore
            this.getData(obj.city_id,obj.region_id)
        },
        props: {
            item: {
                type: Object,
                default: () => {
                }
            },
            index: {
                type: Number,
                default: 0
            }
        },
        components: {

        },
        methods: {

            async getData (city_id,region_id) {
                try {

                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        city_id: city_id,
                        region_id: region_id
                    }

                    await http.post('/wapi/v1/getStoreByCity', data).then(res => {

                        this.tableData = res.data

                    })

                    this.loading = false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            getStatus(status){
                if(status === 'ACTIVE'){
                    return '启用'
                }else{
                    return '停用'
                }
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../assets/css/default';

    .container {
        margin: 10px 0px;
        .tip {
            font-size: 14px;
            color: #3b99f7;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/stores/city.vue